import { render } from "./live-module.vue?vue&type=template&id=6b1edbde"
import script from "./live-module.vue?vue&type=script&lang=js"
export * from "./live-module.vue?vue&type=script&lang=js"

import "./live-module.vue?vue&type=style&index=0&id=6b1edbde&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__